import processesModule from './store/processes'

let auth = null
let GraphQlUrl = null
let gqTools = null
let vueGlobal = null
let globalFormioOptions = null
let globalFormioDependencies = null
let formioIsLoaded = false

export default {
  install(Vue, options) {
    if (!options) {
      throw new Error('Parameters for formio-widget not passed')
    }
    const { formioOptions, dependencies, gqTools } = options
    init(formioOptions, dependencies, gqTools)
    
    vueGlobal = Vue
    globalFormioOptions = formioOptions
    globalFormioDependencies = dependencies
  }
}

export async function installFormio() {
  if (formioIsLoaded) {
    return
  }

  const formio = await import('@it-enterprise/formio')
  await import('@it-enterprise/formio/dist/formio.css')
  vueGlobal.use(formio.default, { options: {...globalFormioOptions, i18nOnly: true }, dependencies: globalFormioDependencies })
  formioIsLoaded = true
}

export { auth, GraphQlUrl, gqTools }

function init(formioOptions, dependencies, GQTools) {
  auth = formioOptions.auth
  GraphQlUrl = formioOptions.GraphQlUrl
  gqTools = GQTools
  dependencies.store.registerModule(processesModule.namespace, processesModule)
}